$(document).ready(function(){
  $('.tab-wrapper .tab-list .tab-item').click(function(){
    if(!$(this).hasClass('active')){
      $(this).parent().find('.active').removeClass('active');
      $(this).addClass('active');
      let selectedTab = $(this).attr('data-id');
      $('.tab-detail-wrapper .tab-detail-inner .content-wrapper > .tab-details').hide();
      $('#'+selectedTab).show();
      if($(window).width() < 749){
        setTimeout(() => {
          $('.tab-detail-wrapper .tab-detail-inner .content-wrapper > .tab-details.active').removeClass('active');
          $('#'+selectedTab).addClass('active');
        }, 70);
      } else {
        $('.tab-detail-wrapper .tab-detail-inner .content-wrapper > .tab-details.active').removeClass('active');
        $('#'+selectedTab).addClass('active');
      }
    }
  });
});